import axios from "@/axios.js"

export default {
  searchUserType({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/usertypes/search_usertype/" + item)
        .then((response) => {
          commit('SET_USER_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  searchAutocomplete({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.get("api/usertypes/search/" + item)
        .then((response) => {
          // // console.log(response)
          commit('SET_AUTOCOMPLETE_DATA', response.data.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  updateUserType({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/usertypes/update_usertype", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('EDIT_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  addUserType({
    commit
  }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/api/usertypes/add_usertypes", {
          item: item
        })
        .then((response) => {
          // // console.log(response)
          commit('ADD_ITEM', Object.assign(item, {
            id: response.data.id
          }))
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllUserTypes({
    commit
  },item) {
    return new Promise((resolve, reject) => {
      axios.get("/api/usertypes/" + item.page_no + "/" + item.per_page)
        .then((response) => {
          commit('SET_USER_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchAllTypes({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/usertypes/types")
        .then((response) => {
          commit('SET_USER_TYPES', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchUserType(context, usertypeId) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/usertypes/${usertypeId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
    fetchUserTypeList({
      commit
    },item) {
    return new Promise((resolve, reject) => {
      axios.get(`/api/usertypes/${item}`)
        .then((response) => {
          commit('SELECTED_USER_TYPE', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  removeUserType({
    commit
  }, usertypeId) {
    return new Promise((resolve, reject) => {
      // alert(usertypeId)
      axios.delete(`/api/usertypes/${usertypeId}`)
        .then((response) => {
          commit('REMOVE_USER_TYPE', usertypeId)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
